import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { navigationState } from 'src/v2/commons/utils/navigation'
import { useAppDispatch } from 'src/v2/store/hooks'

import { checkRoute } from '../actions/routing.actions'

const NavigationManager: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useAppDispatch()

  useEffect(() => {
    navigationState.navigate = navigate
    navigationState.location = location

    return () => {
      navigationState.navigate = undefined
      navigationState.location = undefined
    }
  }, [navigate, location])

  useEffect(() => {
    dispatch(checkRoute({ skipValidation: false }))
  }, [dispatch])

  return null
}

export default NavigationManager
